import { BookingType } from '../types/booking';

import storageValue from './storageValue';

export const BOOKING_STORAGE_KEY = 'BOOKING';

export const getBookingStorage = (): BookingType[] => {
	try {
		return JSON.parse(storageValue(BOOKING_STORAGE_KEY)) || [];
	} catch (e) {
		console.warn(e);
		return [];
	}
};

export const setBookingStorage = (value: BookingType[]) => {
	try {
		storageValue(BOOKING_STORAGE_KEY, JSON.stringify(value));
	} catch (e) {
		console.warn(e);
	}
};

export const updateBookingStorage = (value: BookingType) => {
	const currentValue = getBookingStorage();

	try {
		const foundIndex = currentValue.findIndex((b) => b.guid === value.guid);

		if (foundIndex >= 0) {
			currentValue[foundIndex] = value;
		} else {
			currentValue.push(value);
		}

		setBookingStorage(currentValue);
	} catch (e) {
		console.warn(e);
	}

	return currentValue;
};

export const deleteFromBookingStorage = (guid: string) => {
	const currentValue = getBookingStorage();
	const newValue = currentValue.filter((b) => b.guid !== guid);

	setBookingStorage(newValue);

	return newValue;
};
